import { Dropdown, DropdownButton } from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";

import { EditIcon, TrashIcon } from "../../../constants/icon_path";

const UpdateDropdown = ({ message, handleDelete, toggleEdit }) => {
  return (
    <DropdownButton
      title={<BsThreeDotsVertical color="white" size={20} />}
      variant="link"
      aria-expanded="false"
    >
      <Dropdown.Item onClick={() => toggleEdit(message)}>
        <span>
          <EditIcon color="green" size={25} /> ແກ້ໄຂ
        </span>
      </Dropdown.Item>
      <Dropdown.Item onClick={() => handleDelete(message.id)}>
        <span>
          <TrashIcon color="red" size={25} /> ລຶບ
        </span>
      </Dropdown.Item>
    </DropdownButton>
  );
};

export default UpdateDropdown;
